import { getAnonymousId } from './lib/salesforce-cookie';
import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export interface ICampaignFlags {
    getCampaignFlag: (
        flagName: string,
        defaultValue: string,
    ) => Promise<string>;
    captureCampaignFlagImpression: (flagName: string) => Promise<void>;
}

export function campaignFlags(
    dataset: string,
    { appEventSdk }: DependenciesPayload,
): ICampaignFlags {
    let state: Record<string, string> = {};
    return {
        getCampaignFlag: async (flagName: string, defaultValue: string) => {
            try {
                const campaignFlagResponse = await fetch(
                    `https://siriusxmradioinc.us-6.evergage.com/api2/event/${dataset.toLowerCase()}`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            interaction: {
                                name: flagName,
                            },
                            user: {
                                anonymousId: getAnonymousId(),
                            },
                            source: {
                                channel: 'Web',
                                url: location.href,
                                urlParams: Object.fromEntries(
                                    new URLSearchParams(
                                        window.location.search,
                                    ).entries(),
                                ),
                                urlReferrer: document.referrer,
                            },
                        }),
                    },
                );
                const campaignFlagResponseJson =
                    await campaignFlagResponse.json();
                const campaignResponse =
                    campaignFlagResponseJson.campaignResponses[0];

                if (!campaignFlagResponse.ok) {
                    await Promise.reject(campaignFlagResponseJson);
                    return defaultValue;
                }
                if (!campaignResponse?.payload?.flag) {
                    return defaultValue;
                }

                appEventSdk.trackEvent({
                    event: 'sfcampaign-analytics-serverside-query',
                    salesForceInfoServerSide: {
                        [flagName]: {
                            statType: 'Query',
                            isControl: campaignResponse?.payload?.isControl,
                            campaignId: campaignResponse?.campaignId,
                            campaignName: campaignResponse?.campaignName,
                            campaignType: campaignResponse?.campaignType,
                            experienceId: campaignResponse?.experienceId,
                            experienceName: campaignResponse?.experienceName,
                            payload: campaignResponse?.payload,
                            state: campaignResponse?.state,
                            templateNames: campaignResponse?.templateNames,
                            type: campaignResponse?.type,
                            userGroup: campaignResponse?.payload?.userGroup,
                        },
                    },
                });

                state = {
                    ...state,
                    [flagName]: campaignResponse?.experienceId,
                };

                return campaignResponse?.payload?.flag;
            } catch (error: any) {
                /**
                 * TODO:
                 * Log error to error logger (not analytics).
                 */
                return defaultValue;
            }
        },
        captureCampaignFlagImpression: async (flagName: string) => {
            const experienceId = state[flagName];
            if (experienceId) {
                try {
                    await fetch(
                        `https://siriusxmradioinc.us-6.evergage.com/api2/event/${dataset.toLowerCase()}`,
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                interaction: {
                                    name: 'sfcampaign-analytics-serverside',
                                },
                                user: {
                                    anonymousId: getAnonymousId(),
                                },
                                campaignStats: [
                                    {
                                        experienceId,
                                        stat: 'Impression',
                                        control: false,
                                    },
                                ],
                                source: {
                                    channel: 'Web',
                                    url: location.href,
                                    urlParams: Object.fromEntries(
                                        new URLSearchParams(
                                            window.location.search,
                                        ).entries(),
                                    ),
                                    urlReferrer: document.referrer,
                                },
                            }),
                        },
                    );

                    appEventSdk.trackEvent({
                        event: 'sfcampaign-analytics-serverside-impression',
                        salesForceInfoServerSide: {
                            [flagName]: {
                                statType: 'Impression',
                            },
                        },
                    });
                } catch (error: any) {
                    /**
                     * TODO:
                     * Log error to error logger (not analytics).
                     */
                }
            }
        },
    };
}
